export default __webpack_public_path__ + "static/media/Header-7.acfe1ce7.jpg";